exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-cart-styles-___line-item__unavailableCont___3D4xf{padding-bottom:10px}.src-components-cart-styles-___line-item__phoneRow___1FhkD{display:flex;flex-direction:row;margin-top:10px}.src-components-cart-styles-___line-item__phoneRow___1FhkD i{color:#68583c;cursor:pointer;font-size:16px;margin-left:8px;margin-right:12px}.src-components-cart-styles-___line-item__phones___1Zlui{display:flex;flex-direction:column;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"unavailableCont": "src-components-cart-styles-___line-item__unavailableCont___3D4xf",
	"phoneRow": "src-components-cart-styles-___line-item__phoneRow___1FhkD",
	"phones": "src-components-cart-styles-___line-item__phones___1Zlui"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/cart/styles/line-item.scss
 ** module id = 887
 ** module chunks = 0
 **/